"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
require("./FilteredHeaderColumn.scss");
exports.CustomHeaderColumn = function (props) {
    var _a;
    var column = props.column;
    var clickSort = function (e) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore e being of that exact type is not required here.
        props.onColumnClick(e, props.column);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore e being of that exact type is not required here.
        if (column.onColumnClick) {
            column.onColumnClick(e, column);
        }
    };
    return (react_1.default.createElement("span", { "aria-hidden": true, className: "table-custom-header-cell", onClick: clickSort },
        react_1.default.createElement("span", { className: "table-custom-header-cell-title" }, (_a = column.nameAsJsx) !== null && _a !== void 0 ? _a : column.name),
        column.isSorted && (react_1.default.createElement("span", null,
            react_1.default.createElement(react_2.IconButton, { iconProps: {
                    iconName: column.isSortedDescending ? 'SortDown' : 'SortUp',
                } }))),
        !column.isSorted && column.allowSorting && (react_1.default.createElement("span", null,
            react_1.default.createElement(react_2.IconButton, { iconProps: {
                    iconName: 'Sort',
                } })))));
};
//# sourceMappingURL=CustomHeaderColumn.js.map